import { ROUTES } from '@/constants';

export const sidebarItems = [
	{ label: 'Presentación', to: ROUTES.COLEGIO_PRESENTACION },
	{ label: 'Organización', to: ROUTES.COLEGIO_JUNTA_DIRECTIVA },
	{ label: 'Visita Virtual', to: ROUTES.COLEGIO_VISITA_VIRTUAL },
];
